import { DateTime } from 'luxon'

export class Advert {
	public id: number
	public path: string
	public name: string
	public description: string | null
	public dateStart: DateTime | null
	public dateEnd: DateTime | null

	constructor(data: {
		id: number
		path: string
		name: string
		description: string | null
		dateStart: DateTime | null
		dateEnd: DateTime | null
	}) {
		this.id = data.id
		this.path = data.path
		this.name = data.name
		this.description = data.description
		this.dateStart = data.dateStart
		this.dateEnd = data.dateEnd
	}

	static create(data: Partial<Advert>): Advert {
		const defaultData = {
			id: 0,
			path: '',
			name: '',
			description: null,
			dateStart: null,
			dateEnd: null,
		}

		return new Advert({ ...defaultData, ...data })
	}
}
